import { useEffect } from 'react';

import { rawTrackEngagementEvent } from '../../services/tracking/pulse';

import { VGAccountSharingPopup as VGPopup } from './VGAccountSharingPopup';
import { AccountSharingPopup as ABPopup } from './ABAccountSharingPopup';

import type { FC } from 'react';

export interface AccountSharingPopupProps {
  isOpen: boolean;
  variant: 'vg' | 'ab';
}

export const AccountSharingPopup: FC<AccountSharingPopupProps> = ({
  isOpen,
  variant,
}) => {
  useEffect(() => {
    if (isOpen) {
      rawTrackEngagementEvent({
        intent: 'View',
        object: {
          type: 'UIElement',
          id: 'account-sharing-popup',
        },
      });
    }
  }, [isOpen]);

  return variant === 'vg' ? (
    <VGPopup isOpen={isOpen} />
  ) : (
    <ABPopup isOpen={isOpen} />
  );
};
